import horizontalMixinForScrollPosition from './horizontalMixinForScrollPosition.js'
export default () => ({
    mixins: [horizontalMixinForScrollPosition()]//将导入的文件horizontalMixinForScrollPosition文件混入到该组件中
});